import {useState, useEffect} from 'react';
import ProfileMgmt from './ProfileMgmt';

export default function ProfileMgmtContainer(){
    return (
        <ProfileMgmt/>
    )
}